import { ROUTES } from '@/constants';
import { ax } from '@/utils';

const state = {
    users: null
};

const getters = {
    users: state => state.users,
};

const actions = {
    getUsers({commit}){
        return ax
            .get(ROUTES.LIST_USER())
            .then(res => {
                commit('SET_USERS', res.data.data);
                return res;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getUser(_, id){
        return ax
            .get(ROUTES.USER(id))
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    }
}

const mutations = {
    SET_USERS(state, users) {
        state.users = users
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
